var render = function render(){var _vm=this,_c=_vm._self._c;return _c('model',{attrs:{"feature-list":_vm.featureList,"page-data":_vm.pageData}})
}
var staticRenderFns = []

export { render, staticRenderFns }